import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { UserService } from '../services/user.service';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpService } from '../services/http.service';



@Component({ templateUrl: 'login.component.html', styleUrls: ['./login.component.scss'] })
export class LoginComponent implements OnInit {
    form!: FormGroup;
    loading = false;
    submitted = false;

    constructor(
        private formBuilder: FormBuilder,
        private userService: UserService,
        private router: Router, private route: ActivatedRoute,
        private httpService: HttpService,
    ) { }

    ngOnInit() {
        this.form = this.formBuilder.group({
            username: ['', Validators.required],
            password: ['', Validators.required]
        });
    }

    // convenience getter for easy access to form fields
    get f() { return this.form.controls; }

    onFocus(ele:any){
        ele.target.parentNode.firstElementChild.classList.add("active");
    }

    onBlur(ele:any){
        ele.target.parentNode.firstElementChild.classList.remove("active");
    }

    onSubmit() {
        this.submitted = true;


        // stop here if form is invalid
        if (this.form.invalid) {
            return;
        }

        this.loading = true;
        let data = {Email:this.f.username.value, Password:this.f.password.value};
        this.httpService.post('prod/auth/signin', data).subscribe((res: any) => {
            debugger;
            localStorage.setItem("user", res.token);
            this.router.navigate(['/home']).then(() => {
                window.location.reload();
              });
            },(error:any) => {
                alert(error);
                debugger;
                this.userService.logout();
                this.loading = false;
        });

    }
}